import { EventsConfig } from '@chart/types/events.types';

export const isAssetEnabled = ({
  tag,
  eventsConfig,
}: {
  tag: string;
  eventsConfig: EventsConfig;
}): boolean => {
  const allInsightsEnabled = eventsConfig.TMI;

  if (!eventsConfig.INSIGHTS) {
    return allInsightsEnabled;
  }

  return eventsConfig.INSIGHTS[tag] ?? false;
};

export const handleAllInsightsToggle = ({
  checked,
  uniqueAssets,
  eventsConfig,
  onChange,
}: {
  checked: boolean;
  uniqueAssets: { tag: string }[];
  eventsConfig: EventsConfig;
  onChange: (config: EventsConfig) => void;
}) => {
  const newInsights: Record<string, boolean> = {};
  uniqueAssets.forEach(asset => {
    newInsights[asset.tag] = checked;
  });

  onChange({
    ...eventsConfig,
    TMI: checked,
    INSIGHTS: newInsights,
  });
};

export const handleAssetToggle = ({
  tag,
  checked,
  eventsConfig,
  uniqueAssets,
  onChange,
}: {
  tag: string;
  checked: boolean;
  eventsConfig: EventsConfig;
  uniqueAssets: { tag: string }[];
  onChange: (config: EventsConfig) => void;
}) => {
  const currentInsights =
    eventsConfig.INSIGHTS ??
    Object.fromEntries(uniqueAssets.map(a => [a.tag, true]));

  const newInsights = {
    ...currentInsights,
    [tag]: checked,
  };

  const anyEnabled = Object.values(newInsights).some(Boolean);

  onChange({
    ...eventsConfig,
    TMI: anyEnabled,
    INSIGHTS: newInsights,
  });
};
